import EnumSet from 'Services/enumSet';

interface ICompanyStatus extends EnumSet {
  companyIncompleteCheckout: number,
  companyHasOverdueInvoice: number,
  companyUnableCompleteSubscription: number,
  downgradedPlan: number
}

const companyStatus = new EnumSet({
  companyIncompleteCheckout: { value: 1, description: 'Empresa não completou o checkout' },
  companyHasOverdueInvoice: { value: 2, description: 'Empresa possui fatura em atraso' },
  companyUnableCompleteSubscription: { value: 3, description: 'Empresa não concluiu a assinatura' },
  downgradedPlan: { value: 4, description: "Foi realizado o downgrade do plano das empresa" }
}) as ICompanyStatus;

export default companyStatus;
